import React, { useEffect, useMemo, useState } from 'react';
import {
  Alert,
  Button,
  Typography,
  Row,
  Col,
  Modal,
  Space,
  Form,
  Input,
} from 'antd';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import cn from 'classnames';
import useLicense from '../../../hooks/useLicense';

export default function LicenseExpire({ isTrial, expireDate }) {
  const { t } = useTranslation();
  const { mode, changeMode, saveCode, pending } = useLicense();
  const [licenseNumber, setLicenseNumber] = useState('');
  const [licenseDone, setLicenseDone] = useState(false);
  const [licenseError, setLicenseError] = useState(false);

  const dateStr = useMemo(() => {
    return expireDate ? moment(expireDate).format('L LT') : '-';
  }, [expireDate]);

  const daysStr = useMemo(() => {
    return expireDate ? moment().to(expireDate) : '-';
  }, [expireDate]);

  const isVisible = useMemo(() => !!mode, [mode]);
  const isManual = useMemo(() => mode === 'manual', [mode]);

  const handleChangeLicense = () => {
    changeMode('manual');
  };

  const handleCloseModal = () => {
    changeMode(false);
  };

  const handleChangeLicenseNumber = (e) => {
    setLicenseNumber(e.target.value);
  };

  const handleApplyLicense = () => {
    saveCode({
      body: { key: licenseNumber },
      onSuccess: () => {
        setLicenseError(false);
        setLicenseDone(true);
      },
      onError: (e) => {
        setLicenseDone(false);
        setLicenseError(e.status);
      },
    });
  };

  useEffect(() => {
    setLicenseNumber('');
    setLicenseError(false);
    setLicenseDone(false);
  }, [isVisible]);

  return (
    <div className={cn('license-block', { 'is-trial': isTrial })}>
      {isTrial ? (
        <Alert
          message={
            <Row justify="space-between" align="middle">
              <Col>
                <Typography.Text>
                  {t('trial')} {t('expireText', { date: dateStr })}{' '}
                  <Typography.Text type="danger">({daysStr})</Typography.Text>
                </Typography.Text>
              </Col>
              <Col>
                <Button onClick={handleChangeLicense}>
                  {t('change-license')}
                </Button>
              </Col>
            </Row>
          }
          type="error"
        />
      ) : null}
      <Modal
        visible={isVisible}
        footer={null}
        onCancel={handleCloseModal}
        centered
        width="100%"
        wrapClassName="license-expire__modal"
        maskStyle={{ backgroundColor: 'rgba(114, 46, 209, 0.75)' }}
        maskClosable={isManual}
        closable={isManual}
      >
        <Space direction="vertical">
          <Typography.Title level={3}>
            {mode === 'auto' && t('license-is-over')}
            {mode === 'auto' && ` `}
            {t('enter-code')}
          </Typography.Title>
          <Form>
            <Form.Item validateStatus="success" style={{ marginBottom: 0 }}>
              <Input
                className="license-expire__input"
                value={licenseNumber}
                onChange={handleChangeLicenseNumber}
              />
            </Form.Item>
          </Form>
          <Typography.Text>
            {licenseDone && t('code-is-accepted')}
            {licenseError
              ? licenseError === 400
                ? t('code-is-incorrect')
                : licenseError === 503
                ? t('license-server-unavailable')
                : t('license-activations-error')
              : null}
          </Typography.Text>
          {licenseDone ? (
            <Button type="primary">{t('close')}</Button>
          ) : (
            <Button
              type="primary"
              loading={pending}
              onClick={handleApplyLicense}
            >
              {t('apply')}
            </Button>
          )}
        </Space>
      </Modal>
    </div>
  );
}
